import { Component, Input, OnInit } from '@angular/core';
import { combineLatest, forkJoin, Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { ECVideoService } from '../../shared/ec-modal/ec-video.service';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { OeAppService } from '../../shared/oe-app.service';
import { ProfileServiceConfigurationService } from '../../shared/profile-service-configuration.service';
import { ProgressBarInputData } from '../../shared/types/ProgressBarInputData';
import { GamificationActivityType } from '../../shared/types/gamification-activity-type';
import { ProfileLiteExtService } from '../../shared/profile-lite-ext.service';


@Component({
  selector: 'lp2-practice-section',
  templateUrl: './practice-section.component.html',
  styleUrls: ['./practice-section.component.scss'],
})
export class PracticeSectionComponent implements OnInit {
  @Input()
  activityPoints: Map<GamificationActivityType, number>;

  isMobile: boolean;
  ECLoaded = false;
  ECError = false;

  practiceProgressData: Observable<ProgressBarInputData[]>;
  profileState$ = this.profileService.state$.pipe(filter((state) => !!state));
  showSpeechaceCarousel$ = combineLatest([
    this.profileServiceConfigurationService.isSpeechaceCarouselEnabled$(),
    this.profileState$
  ]).pipe(
    map(([isSpeechaceCarouselEnabled, personData]) => isSpeechaceCarouselEnabled && personData.program.speechAceEnabled)
  )
  showVideosCarousel$ = this.profileState$.pipe(map((personData) => personData.program.ecEnabled));

  businessTopics: string[] = [
    'Business',
    'CEOs',
    'Companies',
    'Earnings Calls',
    'Engineering',
    'Finance',
    'Presentations',
    'Telephone',
    'Working',
  ];

  constructor(
    private levelProgressService: LevelProgressService,
    private oeApp: OeAppService,
    private profileServiceConfigurationService: ProfileServiceConfigurationService,
    private profileService: ProfileLiteExtService,
    videoService: ECVideoService
  ) {
    videoService.initialize(
      () => {
        this.ECLoaded = true;
        this.ECError = false;
      },
      () => {
        this.ECError = true;
        this.ECLoaded = false;
      }
    );
  }

  ngOnInit() {
    this.isMobile = this.oeApp.isMobileDevice();
    this.practiceProgressData = this.levelProgressService.practiceLevelProgress$.pipe(
      map((practiceProgress) => [practiceProgress])
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/practice-section/practice-section.component.ts